import { render, staticRenderFns } from "./SceneMod.vue?vue&type=template&id=11452a22&scoped=true"
import script from "./SceneMod.vue?vue&type=script&lang=js"
export * from "./SceneMod.vue?vue&type=script&lang=js"
import style0 from "./SceneMod.vue?vue&type=style&index=0&id=11452a22&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11452a22",
  null
  
)

export default component.exports